import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  Stack,
  VStack,
  Circle,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  SimpleGrid,
  HStack,
} from "@chakra-ui/react";
import forPlanetLogo from "../../assets/images/for-the-planet.png";
import cleanOcean from "../../assets/images/cleanOcean.png";
import joinUs from "../../assets/images/join-us.jpg";
import planetImpact from "../../assets/images/planet-impact-fund.png";
import Translate from "../LanguageTranslation/Translate";

const OffsetProgram = ({ setActiveStep,cause, setCause }) => {
 
  const programs = [
    {
      img: joinUs,
      logo: cleanOcean,
      title: "The Ocean Cleanup",
      description:
        "This program supports The Ocean Cleanup, a non-profit project focused on developing and scaling technologies to rid the world's oceans of plastic. By contributing to this program, you'll directly help clear away harmful marine debris.",
    },
    {
      img: planetImpact,
      logo: forPlanetLogo,

      title: "Planet Impact Fund",
      description:
        "The 1% for the Planet® Impact Fund, managed by National Philanthropic Trust, supports environmental projects across four crucial areas: Rights to Nature, Conservation & Restoration, Resilient Communities, and Just Economies, creating a sustainable future for all.",
    },
  ];

  return (
    <Box bg="white" px={{ base: 4, md: 12 }} py={8}>
      {/* Section 1: Sales Growth (Image on Right, Text on Left) */}
      <Flex
        direction={{ base: "column-reverse", md: "row" }}
        mb={{ base: 20, md: 20 }}
        maxW={{ base: "auto", md: "80vw", lg: "80vw", xl: "70vw" }}
        justifyContent="center"
        mx="auto"
        h={{ base: "auto", md: "auto", lg: "auto", xl: "auto" }} // Responsive height
      >
        <VStack spacing={0}>
          <Flex
            w="100%"
            // bg="#EBEAF2"
            h={{ base: "auto", md: "auto", lg: "auto", xl: "auto" }}
            alignItems="flex-start"
            justify="space-between"
            direction={{ base: "column", md: "row" }}
          >
            {/* Text Section */}
            <Box
              flex="1"
              borderRadius="lg"
              p={{ base: 6, md: 6 }}
              pl={{ base: 6, md: 6 }}
              pb={{ base: 6, md: 6 }}
              pt={0}
              textAlign={{ base: "center", md: "left" }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              h="100%"
            >
              <Heading
                fontSize={{ base: "2xl", md: "4xl", lg: "5xl" }}
                w={{ base: "100%", md: "100%", lg: "80%" }}
                textAlign="left"
              >
                <Translate text="Offset Your" />{" "}
                <Text
                  as="span"
                  bgGradient="linear(to-r, #286328, #A8E063)" // Changed to the new gradient colors
                  bgClip="text"
                  fontWeight="bold"
                >
                  <Translate text="Carbon Footprint" />
                </Text>
              </Heading>
              <Text
                mt={{ base: 2, md: 4 }}
                fontSize={{ base: "md", md: "lg" }}
                textAlign="left"
                color="gray.600"
              >
                <Translate text="Join us in making a positive impact on the planet. By offsetting your carbon footprint, you’re contributing to a sustainable future. Whether you choose to contribute a small amount or offset your entire itinerary, every action counts." />
              </Text>
            </Box>

            {/* Form Section */}
            <Box
              flex="1"
              borderRadius="lg"
              p={{ base: 6, md: 6 }}
              pl={{ base: 6, md: 6 }}
              pb={{ base: 6, md: 6 }}
              pt={0}
              textAlign={{ base: "center", md: "left" }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              h="100%"
              w={{ base: "100%", md: "auto" }}
            >
              <Stack spacing={3} mt={2} mb={1}>
                <Flex
                  bg="white"
                  p={2}
                  borderRadius="xl"
                  boxShadow="md"
                  alignItems="center"
                >
                  <Circle bg="#286328" color="white" size="8" mr={4}>
                    <Text fontWeight="bold" mb={0}>
                      1
                    </Text>
                  </Circle>
                  <Box w="100%">
                    <Accordion
                      allowToggle
                      // defaultIndex={[0]}
                    >
                      <AccordionItem border="none">
                        <AccordionButton p={0} _hover={{ bg: "transparent" }}>
                          <Box
                            flex="1"
                            textAlign="left"
                            fontWeight="bold"
                            fontSize={{ base: "md", md: "lg" }}
                            mr={2}
                          >
                            <Translate text="Select your Preferred Offset Program" />
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel
                          pl={0}
                          pb={4}
                          color="gray.600"
                          fontSize="sm"
                          textAlign="left"
                        >
                          <Translate text="Choose a program below that fits your values and makes a real difference." />
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </Box>
                </Flex>

                <Flex
                  bg="white"
                  p={2}
                  borderRadius="xl"
                  boxShadow="md"
                  alignItems="center"
                >
                  <Circle bg="#286328" color="white" size="8" mr={4}>
                    <Text fontWeight="bold" mb={0}>
                      2
                    </Text>
                  </Circle>
                  <Box w="100%">
                    <Accordion
                      allowToggle
                      // defaultIndex={[0]}
                    >
                      <AccordionItem border="none">
                        <AccordionButton p={0} _hover={{ bg: "transparent" }}>
                          <Box
                            flex="1"
                            textAlign="left"
                            fontWeight="bold"
                            fontSize={{ base: "md", md: "lg" }}
                            mr={2}
                          >
                            <Translate text="Calculate your Carbon Footprint" />
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel
                          pl={0}
                          pb={4}
                          color="gray.600"
                          fontSize="sm"
                          textAlign="left"
                        >
                          <Translate text="Easily calculate your emissions and take action by offsetting them." />
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </Box>
                </Flex>

                <Flex
                  bg="white"
                  p={2}
                  borderRadius="xl"
                  boxShadow="md"
                  alignItems="center"
                >
                  <Circle bg="#286328" color="white" size="8" mr={4}>
                    <Text fontWeight="bold" mb={0}>
                      3
                    </Text>
                  </Circle>
                  <Box w="100%">
                    <Accordion
                      allowToggle
                      // defaultIndex={[0]}
                    >
                      <AccordionItem border="none">
                        <AccordionButton p={0} _hover={{ bg: "transparent" }}>
                          <Box
                            flex="1"
                            textAlign="left"
                            fontWeight="bold"
                            fontSize={{ base: "md", md: "lg" }}
                            mr={2}
                          >
                            <Translate text="Receive your Unique 'Proof of Impact'" />
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel
                          pl={0}
                          pb={4}
                          color="gray.600"
                          fontSize="sm"
                          textAlign="left"
                        >
                          <Translate text="Get a digital certificate (NFT) to proudly show your positive environmental impact." />
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </Box>
                </Flex>
              </Stack>
            </Box>
          </Flex>
        </VStack>
      </Flex>

      {/* Section 2: AI Creation (Image on Left, Text on Right) */}
      <Flex
        direction={{ base: "column", md: "row-reverse" }}
        alignItems="flex-start" // Align content to the left
        justify="space-between"
        mb={{ base: 0, md: 2 }}
        maxW={{ base: "auto", md: "80vw", lg: "80vw", xl: "70vw" }}
        mx="auto"
        cursor="pointer"
        onClick={() => setActiveStep(1)}
        // h={{ base: "auto", md: "550px", lg: "400px" }} // Responsive height
      >
        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing={6}
          align="center"
          maxW="80vw"
          mx="auto"
        >
          {programs.map((p, i) => (
            <Box key={i}>
              <Image
                src={p.img}
                alt={p.title}
                w={{ base: "100%", md: "90%", lg: "90%", xl: "90%" }}
                // h={{ base: "auto", md: "400px", lg: "400px", xl: "auto" }}
                objectFit="cover"
                borderRadius="40px"
              />
              <Box
                p={4}
                pt={{ base: 4, md: 8 }}
                pl={{ base: 2, md: 8 }}
                textAlign="left"
              >
                <Image
                  src={p.logo}
                  alt={p.title}
                  // w={{ base: "100%", md: "90%" }}
                  h={{ base: "80px", md: "80px", lg: "80px", xl: "100px" }}
                  objectFit="cover"
                  borderRadius="40px"
                  mb={4}
                />
                <Heading
                  fontSize={{ base: "lg", md: "lg", lg: "lg", xl: "24px" }}
                  mb={4}
                >
                  <Translate text={p.title} />
                </Heading>
                <Text
                  mb={4}
                  fontSize={{ base: "md", md: "md", lg: "md", xl: "22px" }}
                  color="gray.600"
                >
                  <Translate text={p.description} />
                </Text>
                <HStack align="center">
                  <Text
                    fontSize={{
                      base: "sm",
                      md: "sm",
                      lg: "sm",
                      xl: "20px",
                    }}
                    fontWeight="bold"
                    color="#286328"
                    cursor="pointer"
                    mb={0}
                    onClick={() => { 
                      console.log('Setting cause to:', p.title);
                      setCause(p.title);
                      // Clear and save new cause to localStorage for persistence
                      localStorage.removeItem('selectedCause');
                      localStorage.setItem('selectedCause', p.title);
                      console.log('Saved to localStorage:', p.title);
                      setActiveStep(1);
                    }}
                  >
                    <Translate text="Contribute to this program" />
                  </Text>
                  <Text
                    fontSize={{
                      base: "sm",
                      md: "sm",
                      lg: "sm",
                      xl: "20px",
                    }}
                    color="#286328"
                    cursor="pointer"
                    mb={0}
                  >
                    <Translate text="➔" />
                  </Text>
                </HStack>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </Flex>
    </Box>
  );
};

export default OffsetProgram;
